import { render, staticRenderFns } from "./TabPositionAppointment.vue?vue&type=template&id=4ff811e3&scoped=true&"
import script from "./TabPositionAppointment.vue?vue&type=script&lang=js&"
export * from "./TabPositionAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff811e3",
  null
  
)

export default component.exports